import { useState, useEffect, useCallback, useMemo } from 'react';
import { useAuth } from '../auth';
import { APIStorage } from '../services/apiStorage';
import { storageLogger } from '../utils/logger';

const POLL_INTERVAL_MS = 60_000;

export function usePendingApprovalsCount(): number {
  const { isHR, isManager } = useAuth();
  const storage = useMemo(() => new APIStorage(), []);
  const [count, setCount] = useState(0);

  const fetch = useCallback(async () => {
    if (!isHR && !isManager) return;
    try {
      const result = await storage.getPendingAbsenceRequestsCount();
      setCount(result.count);
    } catch (err) {
      storageLogger.error('usePendingApprovalsCount: fetch failed', { err });
    }
  }, [isHR, isManager, storage]);

  useEffect(() => {
    void fetch();
    const interval = setInterval(() => void fetch(), POLL_INTERVAL_MS);
    return () => clearInterval(interval);
  }, [fetch]);

  return count;
}
